import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Question from "./component/takeAQuizPage/Question";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);
